import { GreenfieldRequest } from '../../models/greenfield/greenfieldRequest'
import { GreenfieldFilter } from '../../models/greenfield/greenfieldFilter'
import { GreenfieldTimeframe } from '../../models/greenfield/greenfieldTimeframe'
import { AxiosUtil } from '../../utils/axios-util'
import { errorResponseNotification } from '../notification-service'
import { encodeHtml } from '../../utils/CommonUtils'

export const getGreenfieldMetadata = cardId =>
  AxiosUtil.get(`/internal/greenfieldMetadata/${cardId}`).catch(err => {
    errorResponseNotification(err)
    throw err
  })

export const getGreenfieldData = (
  cardId: string,
  request: GreenfieldRequest,
) => {
  return AxiosUtil.post(`/internal/greenfieldData/${cardId}`, request, {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  }).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const getGreenfieldFilterValues = (
  cardId: string,
  dimension: string,
  request: GreenfieldRequest,
  searchString: string | null = null,
) => {
  if (searchString) {
    return AxiosUtil.post(
      `/internal/greenfieldFilterValues/${cardId}?dimension=${dimension}&searchString=${searchString}`,
      request,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    ).catch(err => {
      errorResponseNotification(err)
      throw err
    })
  } else {
    return AxiosUtil.post(
      `/internal/greenfieldFilterValues/${cardId}?dimension=${dimension}`,
      request,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    ).catch(err => {
      errorResponseNotification(err)
      throw err
    })
  }
}

export const autocompleteGetGreenfieldFilterValuesCallback = (
  cardId,
  dimension,
  filters,
  timeframe,
  searchString,
) => {
  return getGreenfieldFilterValues(
    cardId,
    dimension,
    buildRequest(filters, timeframe),
    searchString,
  ).then(res => res.data.query_results)
}

export const buildRequest = (
  filters: GreenfieldFilter[],
  timeframe: GreenfieldTimeframe,
): GreenfieldRequest => {
  return {
    filters: filters.map(filter => ({
      ...filter,
      pattern: filter.pattern?.map(pat => encodeHtml(pat)),
    })),
    time_period: timeframe,
  }
}
